var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgServersideIconCheckBlack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "19.75 19.37 10.52 11.26",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HILFSLINIEN"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_UMGEWANDELT"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#525861",
    d: "M29.978,19.479c-0.287-0.19-0.675-0.113-0.867,0.174l-6.146,9.22l-2.076-3.112 c-0.19-0.287-0.578-0.364-0.866-0.173c-0.287,0.191-0.365,0.579-0.173,0.866l2.596,3.893c0.115,0.174,0.311,0.278,0.52,0.278 s0.404-0.104,0.521-0.278l6.666-10C30.343,20.06,30.265,19.672,29.978,19.479z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_PFADE",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check_2_",
    transform: "translate(618 3423)",
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6560_2_",
    fill: "none",
    stroke: "#363A40",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: " M-597.63-3396.893l2.595,3.893l6.666-10"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "BESCHRIFTUNG"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgServersideIconCheckBlack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/serverside-icon-check-black.ab5ed766.svg";
export { ForwardRef as ReactComponent };